import React from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const PediatricDevelopmentalSessions = () => {
  return (
    <>
      <div className='p-5 lg:p-12 bg-waves bg-cover lg:px-36 min-h-screen space-y-3 lg:grid grid-cols-2'>
        <div>
          <motion.div
            animate={{ x: 0 }}
            initial={{ x: -500 }}
            transition={{ delay: 0.1 }}
          >
            <h3 className='text-black mb-4 text-4xl font-bold lg:text-left md:text-center lg:pl-12'>
              Pediatric Developmental Sessions
            </h3>
          </motion.div>
          <div className='lg:py-4 lg:pr-12'>
            <div className='bg-white p-6 rounded-lg shadow-lg text-left flex-col'>
              <div>
                <p className='text-black sm:text-justify md:text-xl'>
                  Our pediatric development specialists work together with your
                  child to holistically develop their speech, conversation,
                  reading, writing, arithmetic, social, play and fundamental
                  adaptive and executive functioning skills. Ideal for children
                  aged 3 to 8, this service helps support your child to help
                  them reach their maximum potential in all areas. The sessions
                  integrate a wide spectrum of activities and are geared to be
                  fun and play based while providing enforcement of the
                  traditional 3 R’s.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className='lg:pr-12'>
          <img
            className='sm:mx-auto h-auto rounded-3xl drop-shadow-2xl 2xl:mt-9 lg:mt-24'
            src='/pediatric.png'
            alt=''
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PediatricDevelopmentalSessions;
